import React, {Component} from 'react';
import Config from "Config";
import history from "history/history";
import {Context} from './context';
import segment from "../segment";

import Cookies from 'js-cookie';
import fileDownload from "js-file-download";
import {EventSourcePolyfill} from 'event-source-polyfill';
import sortObjectsArray from "sort-objects-array";

import * as BillingController from '../data/controller/BillingController';
import * as DynoController from '../data/controller/DynoController';
import * as LogsController from '../data/controller/LogsController';
import * as ProjectsController from '../data/controller/ProjectsController';
import * as TicketsController from '../data/controller/TicketsController';
import * as UserController from '../data/controller/UserController';
import * as MetaController from '../data/controller/MetaController';
import * as Sentry from '@sentry/browser';
import {isInFlight, pollProjectStatus} from '../data/statusPoll';
import {applyWriteResponse, createSequencer} from '../data/projects/listMerge';
import {describeError, parseBlobError, reportToSentry} from '../data/errors';
import {runExport} from '../data/projects/export';
import CurrencyFormat from "react-currency-format";

export default class ContextProvider extends Component {

    state = {
        // Defaults
        userId: "",
        projectSearchTerm: "",
        projects: [],
        totalProjects: [],
        projectsPerPage: 10,
        toasts: [],
        toastCounter: 0,
        countries: [],
        logs: [],
        totalLogs: 0,
        stats: {
            canCreateAProject: false,
            canCreateSupportTicket: false,
            canMakeProjectWizardProject: false,
            canUseChatSupport: false,
            numberOfProjectSlotsAllowed: 0,
            numberOfProjectSlotsAvailable: 0,
            numberOfWizardsAllowedThisSubscriptionTerm: 0,
            numberOfWizardsRemainingThisSubscriptionTerm: 0
        },
        subscriptions: [],
        subscriptionVariables: {},
        tickets: [],
        ticketsPerPage: 10,
        freeTrialPopup: false,
        lightTheme: false,
        subscriptionPricePerMonth: 14.95,
        wizardsFromPrice: 10,
        patchesFromPrice: 5,
        alwaysShowDecimalPlacesInPrices: false,
        priceEachAbbreviation: 'ea',
        currencySymbol: '€',
        payWall: false,
        priceToPay: 0,
        projectItemsToPurchase: {
            bases: [],
            patches: [],
        },
        product: {
            // Best being even number or will look shit in places
            benefits : [
                'Billed Monthly',
                'Unlimited Manual Projects',
                'Cloud Project Storage',
                'Full File Editor Features',
                'File Editor Map Definitions',
                'Full Project Retention',
                'Stage templates from €10 ea',
                'Addons from €5 ea',
            ]
        },

        publishableToken: null,

        // Entry
        setUserId: this.setUserId.bind(this),
        login: this.login,
        logout: this.logout.bind(this),
        createAccount: this.createAccount,
        verifyEmailAddress: this.verifyEmailAddress.bind(this),
        requestPasswordReset: this.requestPasswordReset,
        checkResetValid: this.checkResetValid,
        resetPassword: this.resetPassword,

        //Mercure
        mercureLogin: this.mercureLogin,
        addEventSourceTopic: this.addEventSourceTopic.bind(this),
        addEventSourceListener: this.addEventSourceListener.bind(this),
        removeEventSourceTopic: this.removeEventSourceTopic.bind(this),
        removeEventSourceListener: this.removeEventSourceListener.bind(this),

        // Projects
        getProject: this.getProject,
        subscribeProjects: this.subscribeProjects.bind(this),
        setProjectsPerPage: this.setProjectsPerPage.bind(this),
        getProjects: this.getProjects.bind(this),
        getProjectIndex: this.getProjectIndex.bind(this),
        getProjectLogs: this.getProjectLogs,
        getAppliedWizards: this.getAppliedWizards,
        uploadFile: this.uploadFile,
        updateProject: this.updateProject,
        exportProject: this.exportProject,
        archiveProject: this.archiveProject,
        unArchiveProject: this.unArchiveProject,
        downloadOriginal: this.downloadOriginal,
        deleteProject: this.deleteProject,
        getProjectTickets: this.getProjectTickets,

        //Protocols
        getMakes: this.getMakes,
        getModels: this.getModels,
        getPowerTrains: this.getPowerTrains,
        getCompatibilityList: this.getCompatibilityList,

        // Wizards
        getWizards: this.getWizards,
        getWizardDynoData: this.getWizardDynoData,
        applyWizard: this.applyWizard,
        applyWizardRaw: this.applyWizardRaw,
        applyProjectResponse: this.applyProjectResponse.bind(this),
        resetProject: this.resetProject,
        purchaseWizards: this.purchaseWizards,

        // Logs
        getLogs: this.getLogs.bind(this),
        getLog: this.getLog,
        updateLog: this.updateLog,
        deleteLog: this.deleteLog,
        downloadLog: this.downloadLog,

        // User
        getUser: this.getUser.bind(this),
        getUserStats: this.getUserStats.bind(this),
        updateProfilePicture: this.updateProfilePicture,
        updatePassword: this.updatePassword.bind(this),
        updateUser: this.updateUser.bind(this),
        closeAccount: this.closeAccount,

        // Billing
        getPlans: this.getPlans,
        getPlan: this.getPlan,
        getSubscriptions: this.getSubscriptions.bind(this),
        getBillingDetails: this.getBillingDetails,
        getPublishableToken: this.getPublishableToken,
        handleRecurlyToken: this.handleRecurlyToken,
        payPalExtraDetails: this.payPalExtraDetails,
        subscribe: this.subscribe,
        changePlan: this.changePlan,
        cancel: this.cancel,
        reactivate: this.reactivate,
        getCheapestPlan: this.getCheapestPlan,
        setTotalPrice: this.setTotalPrice.bind(this),
        setProjectItemsToPurchase: this.setProjectItemsToPurchase.bind(this),
        billingDetails: null,
        setBillingDetails: this.setBillingDetails.bind(this),


        // Tickets
        subscribeTickets: this.subscribeTickets.bind(this),
        getTickets: this.getTickets.bind(this),
        setTicketsPerPage: this.setTicketsPerPage.bind(this),
        getTicket: this.getTicket,
        ticketTotalItems: null,
        getComments: this.getComments,
        createTicket: this.createTicket,
        uploadAttachment: this.uploadAttachment,
        addComment: this.addComment,
        solveTicket: this.solveTicket,
        openSolvedTicket: this.openSolvedTicket,

        // Toasts
        setToast: this.setToast.bind(this),
        unsetToast: this.unsetToast.bind(this),

        // Errors
        errorHandler: this.errorHandler.bind(this),

        // Miscellaneous
        toggleFreeTrialPopup: this.toggleFreeTrialPopup.bind(this),
        togglePayWall: this.togglePayWall.bind(this),
        toggleLightMode: this.toggleLightMode.bind(this),
        getCountries: this.getCountries,
        getProfilePictureRoute: this.getProfilePictureRoute,
        setLightTheme: this.setLightTheme.bind(this),
        niceCurrency: this.niceCurrency,
    };

    eventSource = null;
    eventSourceTopics = [];

    // List fetches are numbered so an older answer cannot overwrite a newer one (DASH 4 5a).
    sequencer = createSequencer();
    // One status poll per in-flight project: project id -> {handle, takingLonger}. A finished poll keeps its entry until the project leaves the in-flight states or the list.
    polls = new Map();
    focusSubscribed = false;
    lastFocusRefresh = -Infinity;
    mercureFailureReported = false;
    // Set by the first hub failure: the later topics are recorded but not connected, so a silent hub delays the first render once, not once per topic.
    hubFailed = false;
    // Set once any source has opened: from then on a failure is mid-session and does not set hubFailed.
    hubEverOpened = false;
    // The hub source's listener map lives here, so a source that fails to open mid-session does not take the listeners with it.
    hubListeners = null;
    closed = false;

    componentWillUnmount() {
        this.closed = true;
        this.stopAllPolls();
        this.unsubscribeFocus();
    }

    //
    // Entry
    //

    /**
     * Set the user's id in context state
     * * @param {string} userId
     */
    setUserId(userId) {
        this.setState({ userId });
    }

    /**
     * Log the user in and set the JWT in local storage
     * @param {string} email
     * @param {string} password
     */
    async login(email, password) {
        try {
            return await UserController.login(email, password);
        } catch(error) {
            console.log(error.response && error.response.status)
            this.setToast(`${error.response.data.message} (${error.response.status})`, 'Danger', 10000);
            throw error
        }
    }

    /**
     * Log the user out by removing their JWT and redirecting them
     */
    async logout() {
        this.closed = true;
        this.stopAllPolls();
        this.unsubscribeFocus();
        Cookies.remove('token', { domain: Config.family });
        if(!this.eventSourceTopics) {
            this.eventSourceTopics = [];
            this.setEventSource();
        }
        Cookies.remove('mercureToken', { domain: Config.family });
        window.location.href = "/log-in";
    }

    /**
     * Create new user accountDetails and log them in
     * @param {string} firstName
     * @param {string} lastName
     * @param {string} email
     * @param {string} password
     */
    async createAccount(firstName, lastName, email, password, captcha) {
        try {
            const account = await UserController.createAccount(firstName, lastName, email, password, captcha);
            if(account) return await UserController.login(email, password);
            this.setToast('Your account has been created. Goto your inbox to receive your verification code.', 'Success', 10000);
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Check the verification code with api to verify the user's email address
     * @param {number} code - 6 digit code
     */
    async verifyEmailAddress(code) {
        try {
            await UserController.verifyEmailAddress(this.state.userId, code);
            this.setToast("Email verified.", "Success", 10000);
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Initiate the password reset process, triggers an email to be sent to the user
     * @param {string} email
     */
    async requestPasswordReset(email) {
        try {
            const res = await UserController.requestPasswordReset(email);
            this.setToast(res.data[0], 'Success', 10000);
            return res;
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Check that a password reset link is still valid by comparing the reset code and userID
     * @param {string} code - the hash provided from API when requesting for a password change
     * @param {string} userId
     */
    async checkResetValid(code, userId) {
        try {
            return await UserController.checkResetValid(code, userId);
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Complete the password reset flow, setting the new password
     * @param {string} code - the hash provided from API when requesting for a password change
     * @param {string} userId
     * @param {string} newPassword
     */
    async resetPassword(code, userId, newPassword) {
        try {
            this.setToast("Password for account changed", 'Success', 10000);
            return await UserController.resetPassword(code, userId, newPassword)
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }


    //
    // Mercure
    //

    async mercureLogin() {
        try{
            const mercureToken = await UserController.mercureLogin();
            Cookies.set("mercureToken", mercureToken, { domain: Config.family, expires: 30 });
            return true;
        } catch(error) {
            console.log(error && error.message);
            Cookies.remove("token");
            Cookies.remove("mercureToken");
            window.location.reload();
            throw error;
        }
    }

    setEventSource() {
        if(this.eventSource !== null) this.eventSource.close();
        if(this.eventSourceTopics.length < 1) {
            this.eventSource = null

            return Promise.resolve();
        }

        let mercureUrl = new URL(`${Config.mercure}`);
        this.eventSourceTopics.forEach((topic, idx) => {
            mercureUrl.searchParams.append("topic", `${Config.api}${topic}`);
        });

        let eventSource = new EventSourcePolyfill(mercureUrl, {
            headers: {
                Authorization: `Bearer ${Cookies.get('mercureToken')}`
            },
        });

        this.hubListeners = this.hubListeners || (this.eventSource && this.eventSource._listeners) || null;
        if(this.hubListeners) eventSource._listeners = this.hubListeners;

        return new Promise((resolve, reject) => {
            let opened = false;
            eventSource.onopen = () => {
                opened = true;
                this.hubEverOpened = true;
                this.hubListeners = eventSource._listeners;
                this.eventSource = eventSource;
                resolve(eventSource)
            };

            eventSource.onerror = (error) => {
                // A hub that never opened is closed so it does not keep retrying in the background; one that dropped later reconnects itself.
                if(!opened) eventSource.close();
                reject(error);
            };
        });
    }

    async addEventSourceTopic(topic) {
        try {
            if(this.eventSourceTopics.includes(topic)) return this.eventSource;
            this.eventSourceTopics = [...this.eventSourceTopics, topic];
            if(this.hubFailed) return this.eventSource;
            await this.setEventSource();
        } catch(error) {
            // A hub that is down at load is not a reason to log the user out or reload: the dashboard works without live updates.
            console.log(error);
            this.eventSource = null;
            // Only a hub that has never opened is given up on; one that worked and then failed is tried again by the next topic.
            const atLoad = !this.hubEverOpened;
            if(atLoad) this.hubFailed = true;
            if(!this.mercureFailureReported) {
                this.mercureFailureReported = true;
                Sentry.captureMessage(atLoad ? 'mercure unavailable at load' : 'mercure unavailable mid-session');
            }
        }
    }

    addEventSourceListener(channel, func) {
        // No hub, no live updates: the page still works, so a missing source is not an error (removeEventSourceListener does the same).
        if(!this.eventSource) return;
        this.eventSource.addEventListener(channel, func)
    }

    async removeEventSourceTopic(topic) {
        if(!this.eventSourceTopics.includes(topic)) return this.eventSource;
        this.eventSourceTopics = this.eventSourceTopics.filter(stateTopic => stateTopic !== topic);
        if(this.hubFailed) return this.eventSource;
        try {
            await this.setEventSource();
        } catch(error) {
            // Same as adding: a hub that fails is not a reason to reject into the page that is unmounting.
            console.log(error);
            this.eventSource = null;
        }
    }

    removeEventSourceListener(channel, func) {
        if(!this.eventSource) return;
        this.eventSource.removeEventListener(channel, func)
    }

    //
    // Projects
    //

    async subscribeProjects() {
        await this.addEventSourceTopic('/projects/{id}');
        if(!this.eventSource) return;
        this.eventSource.addEventListener("message", this.onProjectUpdate);
    }

     onProjectUpdate = async (e) => {
        try {
            let data = JSON.parse(e.data);
            if(Object.keys(data).length === 1) {
                // run delete function
                await this.getProjects();
                history.push("/projects");
                return;
            }

            if(data['@type'] !== "Project") return;

            if(this.state.projects.filter(projects=> projects.id === data.id).length < 1) {
                this.getProjects()
            } else {
                this.updateSubscribedProject(data)
            }
        } catch(error) {
            console.log(error)
        }
    };

    /**
     * Set projects per page in state
     * @param {number} projectsPerPage
     */
    async setProjectsPerPage(projectsPerPage) {
        this.setState({
            projectsPerPage
        }, async () => {
            try {
                return await this.getProjects();
            } catch(error) {
                this.setToast(this.errorHandler(error), 'Danger', 10000);
            }
        })
    };

    async getProject(id) {
        try {
            return await ProjectsController.getProject(id);
        } catch(error) {
            throw error;
        }
    }

    /**
     * Get a given page of project results
     */
    async getProjects({quiet = false} = {}) {
        const sequence = this.sequencer.next();
        try {
            const projects = await ProjectsController.getProjects(10000, this.state.projectSearchTerm, "createdDate", "desc");
            // A newer fetch has already been applied: this answer is older and would overwrite it.
            if(!this.sequencer.isLatest(sequence)) return;
            this.setState({
                projects: this.keepTakingLonger(projects.projects),
                totalProjects: projects.totalProjects
            }, () => this.reconcilePolls());
            this.subscribeFocus();
        } catch(error) {
            // A background refresh (focus, a settled poll) that fails changes nothing and says nothing.
            if(quiet) return;
            this.setState({
                projectSearchTerm: ""
            }, () => {
                this.setToast(`${this.errorHandler(error)} Unable to get projects.`, 'Danger', 10000);
                throw error;
            });
        }
    }

    getProjectIndex(id) {
        return this.state.projects.findIndex((project) => project.id === id)
    }

    /**
     * Fetch a particular project
     * @param {string} id
     */
    async getProjectLogs(id) {
        try {
            return await ProjectsController.getProjectLogs(id)
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Fetch whether or not a wizard has been applied to a project
     * @param {string} id
     */
    async getAppliedWizards(id) {
        try {
            return await ProjectsController.getAppliedWizards(id)
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Upload file to create a new project
     * @param {file} file
     */
    async uploadFile(file) {
        try {
            return await ProjectsController.uploadFile(file)
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Patch project resource
     * @param {object} data - key value pairs to be patched and projectId
     */
    async updateProject(data) {
        try {
            await ProjectsController.updateProject(data);
            this.setToast(`Project details successfully updated.`, 'Success', 10000);
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    updateSubscribedProject(data) {
        this.applyProjectResponse(data);
    }

    /**
     * Replaces the list item with the same id: a Mercure update, or the Project an apply returned (so Export enables without Mercure)
     * @param {object} data - the Project
     */
    applyProjectResponse(data) {
        this.setState((state) => ({
            projects: this.keepTakingLonger(applyWriteResponse(state.projects, data))
        }), () => this.reconcilePolls());
    }

    /**
     * Starts a status poll for every in-flight project that has none, and stops the polls of projects that left the list or the in-flight states.
     * Called after every applied list fetch and every applied project update.
     */
    reconcilePolls() {
        if(this.closed) return;
        const inFlight = this.state.projects.filter((project) => isInFlight(project.tunerStatus)).map((project) => project.id);
        [...this.polls.keys()].forEach((id) => {
            if(!inFlight.includes(id)) this.stopStatusPoll(id);
        });
        inFlight.forEach((id) => this.startStatusPoll(id));
    }

    startStatusPoll(projectId) {
        if(this.polls.has(projectId)) return;
        const entry = {handle: null, takingLonger: false};
        this.polls.set(projectId, entry);
        entry.handle = pollProjectStatus({
            projectId,
            fetchStatus: () => ProjectsController.getStatus(projectId),
            onStatus: (status) => this.writeStatus(projectId, status),
            onTerminal: () => this.getProjects({quiet: true}),
            onTakingLonger: () => {
                entry.takingLonger = true;
                this.updateListItem(projectId, (project) => ({...project, takingLonger: true}));
            },
        });
    }

    stopStatusPoll(projectId) {
        const entry = this.polls.get(projectId);
        if(!entry) return;
        entry.handle.stop();
        this.polls.delete(projectId);
    }

    stopAllPolls() {
        [...this.polls.keys()].forEach((id) => this.stopStatusPoll(id));
    }

    /** Writes a polled state and message onto the list item, so the list and the Processing screen follow the poll. */
    writeStatus(projectId, status) {
        this.updateListItem(projectId, (project) => (
            project.tunerStatus === status.state && project.customerMessage === status.message
                ? project
                : {...project, tunerStatus: status.state, customerMessage: status.message}
        ));
    }

    updateListItem(projectId, update) {
        this.setState((state) => {
            const item = state.projects.find((project) => project.id === projectId);
            if(!item) return null;
            const updated = update(item);
            return updated === item ? null : {projects: state.projects.map((project) => (project === item ? updated : project))};
        });
    }

    /** A list that replaces the items keeps the "taking longer" flag of a project whose poll gave up and that is still in flight. */
    keepTakingLonger(projects) {
        return projects.map((project) => {
            const entry = this.polls.get(project.id);
            return entry && entry.takingLonger && isInFlight(project.tunerStatus) ? {...project, takingLonger: true} : project;
        });
    }

    subscribeFocus() {
        if(this.focusSubscribed || this.closed) return;
        this.focusSubscribed = true;
        window.addEventListener("focus", this.refreshOnFocus);
    }

    unsubscribeFocus() {
        window.removeEventListener("focus", this.refreshOnFocus);
        this.focusSubscribed = false;
    }

    /** Coming back to the tab refreshes the list, at most once every 10 s. */
    refreshOnFocus = () => {
        const now = Date.now();
        if(now - this.lastFocusRefresh < 10000) return;
        this.lastFocusRefresh = now;
        this.getProjects({quiet: true});
    };

    /**
     * Create project version and then export that version
     * @param projectId
     * @param fileName the complete file name to save as, with the extension
     */
    async exportProject(projectId, fileName){
        try {
            return await runExport({
                projectId,
                fileName,
                createVersion: ProjectsController.createVersion,
                download: ProjectsController.exportProject,
                save: fileDownload,
            });
        } catch(error) {
            // runExport has parsed a Blob body already, so this is the one toast.
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Archives project
     * @param projectId
     */
    async archiveProject(projectId){
        try {
            await ProjectsController.archiveProject(projectId);
            this.setToast(`Project Archived.`, 'Success', 10000);
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Archives project
     * @param projectId
     */
    async unArchiveProject(projectId){
        try {
            await ProjectsController.unArchiveProject(projectId);
            this.setToast(`Project un-archived.`, 'Success', 10000);
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Download a project's uploaded binary file
     * @param projectId
     * @param fileName the complete file name to save as, with the extension
     */
    async downloadOriginal(projectId, fileName){
        try {
            const downloadData =  await ProjectsController.downloadOriginal(projectId)
            return fileDownload(downloadData, fileName);
        } catch(error) {
            const parsed = await parseBlobError(error);
            this.setToast(this.errorHandler(parsed), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Delete a project resource
     * @param {string} id
     */
    async deleteProject(id) {
        try {
            await ProjectsController.deleteProject(id);
            this.setToast(`Successfully deleted project: ${id}`, "Success", 10000);
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Fetch a particular projects associated tickets
     * @param {string} projectId
     */
    async getProjectTickets(projectId) {
        try {
            return await ProjectsController.getProjectTickets(projectId)
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    //
    // Protocols
    //

    /**
     * Get all potential makes for a project
     * @param {string} projectId
     */
    async getMakes(projectId) {
        try {
            return await ProjectsController.getMakes(projectId)
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Get all potential models for a project based on selected make
     * @param {string} projectId
     * @param {string} makeId
     */
    async getModels(projectId, makeId) {
        try {
            return await ProjectsController.getModels(projectId, makeId)
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Get all potential powerTrains for a project based on selected make and selected model
     * @param projectId
     * @param makeId
     * @param modelId
     */
    async getPowerTrains(projectId, makeId, modelId) {
        try {
            return await ProjectsController.getPowerTrains(projectId, makeId, modelId)
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    async getCompatibilityList() {
        try {
            return await ProjectsController.getCompatibilityList()
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }


    //
    // Wizards
    //

    /**
     * Get all potential wizards for a project
     * @param {string} projectId
     */
    async getWizards(projectId) {
        try {
            return await ProjectsController.getWizards(projectId)
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Get a wizard's dyno data from the octal-vehiclelookup-api
     * @param dynoHash
     */
    async getWizardDynoData(dynoHash){
        try {
            return await DynoController.getWizardDynoData(dynoHash);
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Apply a wizard to a project
     * @param {string} projectId
     * @param {string} wizardId
     */
    async applyWizard(projectId, wizardId) {
        try {
            return await ProjectsController.applyWizard(projectId, wizardId)
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Apply a wizard to a project without the wrapper's toast: the apply sequence reports once, for all of them
     * @param {string} projectId
     * @param {string} wizardId
     */
    async applyWizardRaw(projectId, wizardId) {
        return await ProjectsController.applyWizard(projectId, wizardId);
    }

    /**
     * Reset a project to its uploaded state - acts like a wizard
     * @param projectId
     * @param type
     */
    async resetProject(projectId, type){
        try {
            const res = await ProjectsController.resetProject(projectId, type);
            if (res && res.data && res.data.id) this.applyProjectResponse(res.data);
            this.setToast(`Project successfully reset to ${type}`, "Success", 10000);
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Purchase wizards patches
     * @param projectId
     * @param items
     * @param coupon
     * @param three_d_secure_action_result_token_id
     */
    async purchaseWizards(projectId, items, coupon, three_d_secure_action_result_token_id){
        try {
            await ProjectsController.purchaseWizards(projectId, items, coupon, three_d_secure_action_result_token_id);
            this.setToast(`Successfully purchased wizards`, "Success", 10000);
        } catch(error) {
            if(error?.response?.data?.error?.message){
                reportToSentry(error);
                this.setToast(error.response.data.error.message, 'Danger', 10000);
            } else {
                this.setToast(this.errorHandler(error), 'Danger', 10000);
            }
            throw error;
        }
    }

    //
    // Logs
    //

    /**
     * Get log results
     */
    async getLogs(logsPerPage) {
        try {
            const logs = await LogsController.getLogs(logsPerPage, "createdDate", "desc");
            this.setState({
                logs: logs.logs,
                totalLogs: logs.totalLogs
            })
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Get a log
     */
    async getLog(id) {
        try {
          return await LogsController.getLog(id);
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Patch log resource
     * @param {object} data - key value pairs to be patched and id
     */
    async updateLog(data) {
        try {
            await LogsController.updateLog(data);
            this.setToast(`Log details successfully updated.`, 'Success', 10000);
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Delete a log
     */
    async deleteLog(id) {
        try {
            await LogsController.deleteLog(id);
            this.setToast("Successfully deleted log.", "Success", 10000);
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Download log csv
     * @param logId
     * @param fileName
     */
    async downloadLog(logId, fileName){
        try {
            const file = await LogsController.downloadLog(logId);
            return fileDownload(file, `${fileName}.csv`);
        } catch(error) {
            const parsed = await parseBlobError(error);
            this.setToast(this.errorHandler(parsed), 'Danger', 10000);
            throw error;
        }
    }

    //
    // User
    //

    /**
     * Get the user, their profile picture and subscription
     * @param {string} id
     */
    async getUser(id) {
        try {
            const user = await UserController.getUser(id);

            if(user.verifiedEmail) {
                await this.getSubscriptions();
                const profilePicture = await UserController.getProfilePicture();

                let plan = "Free";
                let status;
                if(this.state.subscriptions.length > 0) {
                    plan = this.state.subscriptions[0].subscriptionPlan.name;
                    status = this.state.subscriptions[0].status;
                    user.dateTrialEnds = this.state.subscriptions[0].dateTrialEnds;
                }
                user.plan = plan;
                user.status = status;
                user.profilePicture = profilePicture;
            }

            this.setState({ user });
        } catch(error) {
            console.log(error && error.message)
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /** Get this user's subscription usage stats and allowances */
    async getUserStats() {
        try {
            const stats = await UserController.getUserStats();
            this.setState({ stats })
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    // todo - should this call getUser? Or at least set the new profilePicture in state?
    /**
     * Update the user's profile picture
     * @param file
     */
    async updateProfilePicture(file) {
        try {
            await UserController.updateProfilePicture(file);
            this.setToast('Profile picture changed successfully.', 'Success', 10000);
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Update the user's password (using old password for auth)
     * @param oldPassword
     * @param newPassword
     */
    async updatePassword(oldPassword, newPassword) {
        try {
            await UserController.updatePassword(this.state.userId, oldPassword, newPassword)
            this.setToast('Password changed successfully.', 'Success', 10000);
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Update the user resource
     * @param {object} data - any data object sent from a component; contains user data
     */
    async updateUser(data) {
        try {
            const user = await UserController.updateUser(this.state.userId, data);
            this.setState({
                user: {
                    ...this.state.user,
                    ...user,
                    profilePicture: this.state.user.profilePicture
                }
            });
            this.setToast('Details updated successfully', 'Success', 10000);
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    // todo - Does this need to log them out?
    /**
     * Close the accountDetails
     * @param userId
     */
    async closeAccount(userId) {
        try {
            await UserController.closeAccount(userId);
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }


    //
    // Billing
    //

    /** Get all available subscription plans */
    async getPlans() {
        try {
            return await BillingController.getPlans()
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    async getCheapestPlan() {
        try {
            let cheapestAmount = 999999999999999999;
            let cheapestPlan;
            let plans = await BillingController.getPlans();
            plans.forEach(plan => {
                if (plan.unitAmount < cheapestAmount) {
                    cheapestAmount = plan.unitAmount;
                    cheapestPlan = plan;
                }
            });
            return cheapestPlan;
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Get a specific subscription plan
     * @param {string} secondaryResourceId
     */
    async getPlan(secondaryResourceId) {
        try {
            return await BillingController.getPlan(secondaryResourceId)
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /** Get this user's active subscription */
    async getSubscriptions() {
        try {
            let subscriptions = await BillingController.getSubscriptions();
            let subscriptionVariables = this.getSubscriptionVariables(subscriptions);

            this.setState({
                subscriptions,
                subscriptionVariables
            })
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /** Get this user's trial info */
    getSubscriptionVariables(subscriptions) {
        try {
            let subscriptionVariable = {};
            let today = new Date();

            subscriptionVariable.isNewUser = subscriptions.length === 0;

            if(subscriptions.length > 0) {
                subscriptionVariable.isProUser = subscriptions[0]?.status !== "expired"
                subscriptionVariable.expDate = new Date(subscriptions[0].dateExpires)
                subscriptionVariable.hasHadTrial = !!subscriptions.find(sub => !!sub.dateTrialEnds)

                let trialExistsInCurrentSub = !!subscriptions[0]?.dateTrialEnds
                if(trialExistsInCurrentSub) {
                    subscriptionVariable.trialEnds = new Date(subscriptions[0]?.dateTrialEnds);
                    subscriptionVariable.isTrialActive = today < subscriptionVariable.trialEnds;
                    subscriptionVariable.noSubAfterTrial = !!subscriptions[0].dateExpires && new Date(subscriptionVariable.expDate).getTime() === subscriptionVariable.trialEnds.getTime() && !subscriptionVariable.isProUser
                }
            } else {
                subscriptionVariable.isProUser = false;
                subscriptionVariable.hasHadTrial = false;
            }

            subscriptionVariable.isTrialAvailable = !subscriptionVariable.isProUser && !subscriptionVariable.hasHadTrial;

            return subscriptionVariable;
        } catch(error) {
            console.log(error && error.message)
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /** Get this user's billing details */
    async getBillingDetails() {
        try {
            return await BillingController.getBillingDetails()
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /** Get our publishable token for Recurly depending on env */
    async getPublishableToken() {
        let publishableToken = Cookies.get("publishableToken");

        if (!publishableToken) {
            try {
                const publishableToken = await BillingController.getPublishableToken()
                Cookies.set("publishableToken", publishableToken, { domain: Config.family, expires: 30 });
            } catch(error) {
                this.setToast(this.errorHandler(error), 'Danger', 10000);
                throw error;
            }
        }

        return publishableToken;
    }

    /** Handle the token returned by Recurly when setting billing detail objects */
    async handleRecurlyToken(token_id, three_d_secure_action_result_token_id) {
        try {
            return await BillingController.handleRecurlyToken(token_id, three_d_secure_action_result_token_id)
        } catch(error) {
            throw error;
        }
    }

    async payPalExtraDetails(id, data) {
        try {
            return await BillingController.payPalExtraDetails(id, data);
        } catch(error) {
            throw error;
        }
    }

    /**
     * Subscribe the user to a particular plan
     * @param planId
     * @param coupon
     */
    async subscribe(planId, coupon, three_d_secure_action_result_token_id) {
        try {
            await BillingController.subscribe(planId, coupon, three_d_secure_action_result_token_id);
        } catch(error) {
            // A Recurly customer message (a decline, or a 3D Secure step with its token) is Subscribe.js's to show inline or to
            // answer with the challenge: no toast and no report here. Anything else gets errorHandler's message and its report.
            if(!error?.response?.data?.error?.message){
                this.setToast(this.errorHandler(error), 'Danger', 10000);
            }
            throw error;
        }
    }

    /**
     * Upgrade or downgrade a particular subscription to a different plan
     * @param subscriptionId
     * @param planId
     * @param coupon
     */
    async changePlan(subscriptionId, planId, coupon) {
        try {
            await BillingController.changePlan(subscriptionId, planId, coupon);
            this.setToast("Plan changed successfully.", "Success", 10000)
        } catch(error) {
            this.setToast(error.response.data.error.message, 'Danger', 10000);
            throw error;
        }
    }

    /** Cancel a subscription */
    async cancel(subscriptionId, cancelReason) {
        try {
            await BillingController.cancel(subscriptionId, cancelReason);
            this.setToast("Plan canceled successfully.", "Success", 10000)
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /** Reactivate a cancelled subscription */
    async reactivate(subscriptionId){
        try {
            await BillingController.reactivate(subscriptionId);
            this.setToast("Plan activated successfully. Welcome back.", "Success", 10000)
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }


    //
    // Tickets
    //

    async subscribeTickets() {
        await this.addEventSourceTopic('/tickets/{id}');
        if(!this.eventSource) return;
        this.eventSource.addEventListener("message", this.onTicketsUpdate);
    }

    onTicketsUpdate = async (e) => {
        try {
            let data = JSON.parse(e.data);
            if(data['@type'] !== "Ticket") return;

            if(this.state.tickets.filter(ticket=> ticket.id === data.id).length < 1) {
                this.getTickets()
            } else {
                this.updateSubscribedTickets(data)
            }
        } catch(error) {
            console.log(error)
        }

    };

    updateSubscribedTickets(data) {
        let contextTickets = this.state.tickets;

        if(data.ticketThreadItems.length > 0){
            let dataSort = data.ticketThreadItems.sort((item1, item2) => new Date(item2.createdDate) - new Date(item1.createdDate));
            let dataId = dataSort[0].createdBy.split('/')[3];
            let urlId = window.location.href.split('/');
            if (dataId !== this.state.userId && urlId[urlId.length - 1] !== data.id) this.setToast(`Ticket - ${data.subject} - has a new message`, 'Success', 10000, `${Config.dashboard}/support-tickets/ticket/${data.id}`);
        }

        contextTickets = contextTickets.map((ticket, idx) => {
            if (ticket.id === data.id) {
                return data;
            }
            return ticket
        });

        this.setState({
            tickets: contextTickets
        })
    }

    /**
     * Get a given page of ticket results
     */
    async getTickets () {
        try {
            let res = await TicketsController.getTickets(10000);
            this.setState({
                tickets: res.tickets,
                ticketTotalItems: res.totalItems
            })
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Set projects per page in state
     * @param {number} ticketsPerPage
     */
    async setTicketsPerPage(ticketsPerPage) {
        this.setState({
            ticketsPerPage
        }, async () => {
            try {
                return await this.getTickets();
            } catch(error) {
                this.setToast(this.errorHandler(error), 'Danger', 10000);
            }
        })
    };

    /**
     * Get a specific ticket
     * @param {string} id
     */
    async getTicket(id) {
        try {
            return await TicketsController.getTicket(id)
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Get a ticket's comments
     * @param ticketId
     */
    async getComments(ticketId){
        try {
            return await TicketsController.getComments(ticketId)
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Create a new ticket
     * @param {string} ticketType
     * @param {string} priority
     * @param {string} subject
     * @param {string} notes
     * @param {string} projectId
     * @param {array} attachments
     */
    async createTicket(ticketType, priority, subject, notes, projectId, attachments){
        try {
            return await TicketsController.createTicket(ticketType, priority, subject, notes, projectId, attachments)
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Add an attachment to a ticket
     * @param {file} file
     */
    async uploadAttachment(file) {
        try {
            return await TicketsController.uploadAttachment(file)
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Add a comment to a ticket
     * @param {string} ticketId - the ticket id of the selected ticket
     * @param {string} status
     * @param {string} priority
     * @param {string} message
     * @param {array} attachments
     */
    async addComment(ticketId, status, priority, message, attachments) {
        try {
            return await TicketsController.addComment(ticketId, status, priority, message, attachments)
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * Solve a ticket
     * @param ticketId
     */
    async solveTicket(ticketId) {
        try {
            return await TicketsController.solveTicket(ticketId)
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /**
     * open a solved a ticket
     * @param ticketId
     */
    async openSolvedTicket(ticketId) {
        try {
            return await TicketsController.openSolvedTicket(ticketId)
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    //
    // Toasts
    //

    /**
     * Set a new toast
     * @param {string} message
     * @param {string} type - 'Brand', 'Success', 'Neutral' and 'Danger'
     * @param {number} timeout - Timeout time for toast in ms. If undefined provided, toast will not timeout.
     */
    setToast(message, type, timeout=0) {
        const toasts = this.state.toasts.filter(toast => toast.message !== message);
        let id = this.state.toastCounter;

        this.setState({
            toasts: [ ...toasts, {
                id: this.state.toastCounter,
                message,
                type,
            }],
            toastCounter: this.state.toastCounter + 1,
        },() => {
            if(timeout !== 0){
                window.setTimeout(() => {
                    this.unsetToast(id)
                }, timeout)
            }
        });
    };

    /**
     * Unset a toast
     * @param id
     */
    unsetToast(id) {
        const toasts = this.state.toasts;
        let index = toasts.findIndex((toast) => toast.id === id);
        if(index < 0) return;
        toasts.splice(index, 1);

        this.setState({ toasts });
    };


    //
    // Errors
    //

    /**
     * Determines what to do based on the error status code of a request
     * @param error - Error passed in from Axios
     * @param logoutOn401 - whether a 401 response code should log the user out
     */
    errorHandler(error, logoutOn401 = true) {
        //todo: make this a middleware of axios and remove actions taken in 401
        reportToSentry(error);
        const {message, extraToast, logout} = describeError(error, {route: error.config?.url});
        if (logout && logoutOn401) this.logout();
        if (extraToast) this.setToast(extraToast, 'Danger', 10000);
        return message;
    }

    async toggleFreeTrialPopup(toggle) {
        this.setState({
            freeTrialPopup: toggle
        })
    };

    async toggleLightMode() {
        this.setState({
            lightTheme: !this.state.lightTheme
        }, () => {
            Cookies.set('lightTheme', this.state.lightTheme, { domain: Config.family, expires: 30 });
        })
    };

    /** Get all countries from the api and sort them */
    async getCountries(){
        try {
            let countries = await MetaController.getCountries();
            return sortObjectsArray(countries, "countryName");
        } catch(error) {
            this.setToast(this.errorHandler(error), 'Danger', 10000);
            throw error;
        }
    }

    /** Return the appropriate URL for profile pictures based on env */
    getProfilePictureRoute(){
        switch(process.env.REACT_APP_ENV){
            case "develop": return process.env.REACT_APP_PROFILE_STAGE;
            case "stage": return process.env.REACT_APP_PROFILE_STAGE;
            case "production": return process.env.REACT_APP_PROFILE_PROD;
            default: return process.env.REACT_APP_PROFILE_PROD;
        }
    }

    setLightTheme(theme){
        this.setState({
            lightTheme: theme
        })
    }

    togglePayWall(toggle) {
        this.setState({
            payWall: toggle
        })
    };

    setTotalPrice(price) {
        this.setState({
            priceToPay: price
        });
    }

    setBillingDetails(billingDetails) {
        this.setState({
            billingDetails
        });
    }

    setProjectItemsToPurchase(projectItemsToPurchase) {
        this.setState({
            projectItemsToPurchase: projectItemsToPurchase
        });
    }

    niceCurrency(price) {
        return <CurrencyFormat value={price} displayType={'text'} thousandSeparator={true} prefix={this.currencySymbol} decimalScale={2} fixedDecimalScale={this.alwaysShowDecimalPlacesInPrices} renderText={value => <>{value}</>} />
    }

    render() {
        return (
            <Context.Provider value={{ ...this.state }}>
                {this.props.children}
            </Context.Provider>
        )
    }
}
